const MediaBreakpoint = {};

MediaBreakpoint.breakpoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1400
};

MediaBreakpoint.up = function(breakpoint, handler) {
	// Zaregistruj handler od daného breakpointu
	if (handler) {
		window.addEventListener("resize", function() {
			handler(MediaBreakpoint.up(breakpoint));
		}, { pasive: true })

		window.addEventListener("orientationchange", function() {
			handler(MediaBreakpoint.up(breakpoint));
		}, { pasive: true })
	}

	// Vrať, jestli je daný breakpoint aktivní
	return MediaBreakpoint.breakpoints[breakpoint] <= window.innerWidth;
};

MediaBreakpoint.down = function(breakpoint, handler) {
	// Zaregistruj handler od daného breakpointu
	if (handler) {
		window.addEventListener("resize", function() {
			handler(MediaBreakpoint.down(breakpoint));
		}, { pasive: true })

		window.addEventListener("orientationchange", function() {
			handler(MediaBreakpoint.down(breakpoint));
		}, { pasive: true })
	}

	// Vrať, jestli je daný breakpoint aktivní
	return window.innerWidth < MediaBreakpoint.breakpoints[breakpoint];
};

window.MediaBreakpoint = MediaBreakpoint;
export { MediaBreakpoint };